import { Flow } from "../types/IFlow";
import { NoConfirmationRebookFlowLegacyNames } from "../types/FlowNames";
import {
  NoConfirmationDefaultNavigatorConfiguration,
  NoConfirmationPreQualifiedPatientNavigatorConfiguration
} from "./NavigatorConfigurations";
import { noConfirmationStaticCenterBookingStepConfigurations, screeningStepConfigurations } from "./StepConfigurations";

const noConfirmationRebookFlowName = "NoConfirmationRebookFlow";

/** The flow that a rebook guest should experience when booking without a confirmation step. */
class NoConfirmationRebookFlow extends Flow {
  static readonly flowName = noConfirmationRebookFlowName;
  readonly name = noConfirmationRebookFlowName;
  readonly steps = { ...screeningStepConfigurations, ...noConfirmationStaticCenterBookingStepConfigurations };
  readonly navigatorItems = [...NoConfirmationDefaultNavigatorConfiguration];
  isDisqualificationPossible() {
    return true;
  }

  override matchesFlowName(name: string): boolean {
    return name === this.name || NoConfirmationRebookFlowLegacyNames.includes(name);
  }
}

/** The flow that a pre-qualified rebook guest should experience when booking without a confirmation step. */
export class PreQualifiedNoConfirmationRebookFlow extends Flow {
  readonly name = noConfirmationRebookFlowName;
  readonly steps = { ...noConfirmationStaticCenterBookingStepConfigurations };
  readonly navigatorItems = [...NoConfirmationPreQualifiedPatientNavigatorConfiguration];
  isDisqualificationPossible() {
    return false;
  }

  override matchesFlowName(name: string): boolean {
    return name === this.name || NoConfirmationRebookFlowLegacyNames.includes(name);
  }
}

export default NoConfirmationRebookFlow;
